(function () {
  const STORAGE_KEY = "announcement_closed";
  const STORAGE_KEY_TEXT = "announcement_text";
  const MOBILE_BREAKPOINT = 765;

  const getText = () =>
    window.ANNOUNCEMENT_TEXT ||
    document.querySelector(".announcement-bar__message")?.textContent?.trim() ||
    "";

  const getHeight = () => {
    const heightDesktop = window.ANNOUNCEMENT_HEIGHT_DESKTOP || 0;
    const heightMobile = window.ANNOUNCEMENT_HEIGHT_MOBILE || 0;

    return window.innerWidth >= MOBILE_BREAKPOINT
      ? `${heightDesktop}px`
      : `${heightMobile}px`;
  };

  const isClosed = () => {
    const savedText = localStorage.getItem(STORAGE_KEY_TEXT)?.trim() || "";

    return (
      localStorage.getItem(STORAGE_KEY) === "true" && savedText === getText()
    );
  };

  const apply = () => {
    const root = document.documentElement;
    const closed = isClosed();

    root.classList.toggle("announcement-hidden", closed);
    root.style.setProperty(
      "--announcement-height",
      closed ? "0px" : getHeight()
    );
  };

  const closeAnnouncement = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    localStorage.setItem(STORAGE_KEY_TEXT, getText());
    apply();
  };

  const bindClose = () => {
    document
      .querySelectorAll(".announcement-bar__close-button")
      .forEach((btn) => {
        btn.onclick = closeAnnouncement;
      });
  };

  const init = () => {
    apply();
    bindClose();
  };

  let resizeRaf = null;
  const onResize = () => {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(apply);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("resize", onResize);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:change", init);
  document.addEventListener("shopify:section:select", init);
})();
